<spe-alert [class]="apiStatus" [message]="message"></spe-alert>

<div class="row justify-content-between">
  <div class="col-lg-6">
    <spe-titulo-sessao titulo="Cadastro Manual" icone="/assets/icones/cinza/teclado.svg"> </spe-titulo-sessao>

    <spe-item-lista-simples
      rota="/home/dadosEmpresa"
      descricao="Dados da empresa"
      icon="/assets/icones/vermelho/completed.svg"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      descricao="Contatos"
      rota="/home/dadosEmpresa/contato"
      [icon]="listaDados.contatos > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.contatos <= 0 ? 'Incompleto' : undefined"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      rota="/home/dadosEmpresa/endereco"
      [icon]="listaDados.enderecos > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.enderecos <= 0 ? 'Incompleto' : undefined"
      descricao="Endereços"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      rota="/home/dadosEmpresa/departamento"
      [icon]="listaDados.departamentos > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.departamentos <= 0 ? 'Incompleto' : undefined"
      descricao="Departamentos"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      rota="/home/dadosEmpresa/cargo"
      [icon]="listaDados.cargos > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.cargos <= 0 ? 'Incompleto' : undefined"
      descricao="Cargos"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      rota="/home/dadosEmpresa/periodo"
      [icon]="listaDados.turnos > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.turnos <= 0 ? 'Incompleto' : undefined"
      descricao="Períodos"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      rota="/home/funcionarios/listagem"
      [icon]="listaDados.funcionarios > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.funcionarios <= 0 ? 'Incompleto' : undefined"
      descricao="Funcionários"
    ></spe-item-lista-simples>

    <spe-item-lista-simples
      rota="/home/funcionarios/itensEspecificos"
      [icon]="listaDados.beneficios > 0 ? '/assets/icones/vermelho/completed.svg' : undefined"
      [texto]="listaDados.beneficios <= 0 ? 'Incompleto' : undefined"
      descricao="Itens específicos"
    ></spe-item-lista-simples>
  </div>

  <div class="col-lg-5">
    <spe-titulo-sessao titulo="Importar dados" icone="/assets/icones/cinza/upload.svg"> </spe-titulo-sessao>

    <spe-item-lista-simples
      rota="home/importacao/importar-arquivo"
      [icon]="isCaixa ? '/assets/icones/azul/arrow-right.svg' : '/assets/icones/vermelho/arrow-right.svg'"
      descricao="Importar dados"
    ></spe-item-lista-simples>
  </div>
</div>

<div *ngIf="showAvisoTermosDeContrato" class="pt-32">
  Os Termos do nosso Contrato de Prestação de Serviços foram atualizados.
  <a (click)="openTermoFidelidade()" class="link-red">Saiba mais</a>
</div>

